import {Button, Grid, FormControl, FormControlLabel, Checkbox} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {useTranslation} from "react-i18next";
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import MonthSelect from '../MonthSelect.js';
import CountryCombo from '../CountryCombo.js';
import YearSelect from '../YearSelect.js';

const LButton = (props) => {
	if (!props.compare)
		return null;

	return (
		<Button 
		    disabled={!props.compare.leftIsEnabled} 
		    onClick={props.compare.leftAdd}>
			<AddCircleOutlineIcon/>
			L&nbsp;
		</Button>
	);
}

const RButton = (props) => {
	if (!props.compare)
		return null;

	return (
		<Button 
		    disabled={!props.compare.rightIsEnabled} 
		    onClick={props.compare.rightAdd}>
			<AddCircleOutlineIcon/>
			&nbsp;R
		</Button>
	);
}

const CountrySel = (props) => {
	const gStorage = useGlobalStorage();

	if (!props.country)
		return null;

	function countryChange(event, value) {
// 		console.log('countryChange', event.target.value);

		const country = gStorage.lists.countrylist.find(c => c.id === event.target.value);

		gStorage.stats.setCountry(country);
		gStorage.stats.setObsList(null);
	}

	return (
		<CountryCombo
			value={props.country.value.id}
			onChange={props.country.onChange ? props.country.onChange : countryChange}
			style={{...props.country.style, marginBottom: 8, textAlign: 'left'}}
		/>
	);
}

const YearSel = (props) => {
	if (!props.year)
		return null;

	return (
		<YearSelect 
			year={props.year.year}
			yearChange={props.year.onChange}
			allowNone={props.year.allowNone}
			enabled={props.year.enabled}
		/>
	);
}

const MonthSel = (props) => {
	if (!props.month)
		return null;

	return (
		<Grid style={{marginTop:8}}>
			<LButton compare={props.compare} />
			<FormControl>
				<MonthSelect 
					month={props.month.month} 
					monthChange={props.month.onChange} 
				/>
			</FormControl>
			<RButton compare={props.compare} />
		</Grid>
	);
}

const AllUsersSel = (props) => {
	const {t} = useTranslation('obs');

	if (!props.all_users)
		return null;

	return (
		<Grid>
			<FormControl>
				<FormControlLabel
					label={t('stats.all_users')}
					labelPlacement="start"
					checked={props.all_users.checked}
					onChange={props.all_users.onChange}
					disabled={!props.all_users.enabled}
					control={<Checkbox color="primary" />}
					xs={{m: 8}}
				/>
			</FormControl>
		</Grid>
	);
}

const StatsFilter = (props) => {
	const country = props.loc ? props.loc.country : null;
	const year = props.time ? props.time.year : null;
	const month = props.time ? props.time.month : null;

	const countryCompare = props.compare && props.compare.pos === 'country' ? props.compare : null;
	const yearCompare = props.compare && (props.compare.pos === 'year' || !props.compare.pos) ? props.compare : null;
	const monthCompare = props.compare && props.compare.pos === 'month' ? props.compare : null;

	return (
		<>
			<Grid container direction="row" justifyContent="center" alignItems="center" >
				<LButton compare={countryCompare} />
				<CountrySel country={country}/>
				<RButton compare={countryCompare} />
			</Grid>

			<Grid>
				<LButton compare={yearCompare} />
				<YearSel year={year} />
				<RButton compare={yearCompare} />
			</Grid>

			<MonthSel month={month} compare={monthCompare} />
			<AllUsersSel all_users={props.all_users}/>
		</>
	);
}

export default StatsFilter;
